'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objAsArray = require('shared/utils/objAsArray');

var _objAsArray2 = _interopRequireDefault(_objAsArray);

var _getTitleForLevel = require('shared/utils/getTitleForLevel');

var _getTitleForLevel2 = _interopRequireDefault(_getTitleForLevel);

var _getAllMatchingJobs = require('shared/utils/getAllMatchingJobs');

var _getAllMatchingJobs2 = _interopRequireDefault(_getAllMatchingJobs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JOB_LEVELS = {
  entry: '1',
  mid: '2',
  senior: '3'
};

var getSectorForRoute = function getSectorForRoute(route, _ref) {
  var _ref$data = _ref.data,
      jobs = _ref$data.jobs,
      subsectors = _ref$data.subsectors;

  var _route$split$filter = route.split('/').filter(function (el) {
    return el;
  }),
      _route$split$filter2 = (0, _slicedToArray3.default)(_route$split$filter, 2),
      section = _route$split$filter2[0],
      slug = _route$split$filter2[1];

  if (section === 'job') {
    var job = jobs[slug];
    return job.subsectors[0];
  }

  // subsectors are keyed by ID, not by
  // slug, since slugs are generated client side
  var subsectorID = (0, _keys2.default)(subsectors).filter(function (id) {
    var subsector = subsectors[id];
    return subsector.slug === slug;
  });

  return subsectorID[0];
};

var getJobsForSector = function getJobsForSector(sectorID) {
  var jobs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return jobs.filter(function (job) {
    return job.subsectors.indexOf(sectorID) !== -1;
  });
};

var getJobsForLevel = function getJobsForLevel(level) {
  var jobs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return jobs.filter(function (job) {
    return job.level === level;
  });
};

var getJobsWithSubsectors = function getJobsWithSubsectors(jobs, subsectors) {
  return jobs.map(function (job) {
    return (0, _extends3.default)({}, job, {
      subsectors: job.subsectors.map(function (subsectorID) {
        return (0, _extends3.default)({}, subsectors[subsectorID]);
      })
    });
  });
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref2) {
  var route = _ref2.route;

  var sectorID = getSectorForRoute(route, state);
  var sectorJobs = getJobsForSector(sectorID, (0, _objAsArray2.default)(state.data.jobs));
  var jobs = (0, _getAllMatchingJobs2.default)(state, getJobsWithSubsectors(sectorJobs, state.data.subsectors));
  return {
    columns: [(0, _extends3.default)({}, (0, _getTitleForLevel2.default)('1'), {
      jobs: getJobsForLevel(JOB_LEVELS.entry, jobs)
    }), (0, _extends3.default)({}, (0, _getTitleForLevel2.default)('2'), {
      jobs: getJobsForLevel(JOB_LEVELS.mid, jobs)
    }), (0, _extends3.default)({}, (0, _getTitleForLevel2.default)('3'), {
      jobs: getJobsForLevel(JOB_LEVELS.senior, jobs)
    })]
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps() {
  return {};
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/AllJobs/selectors.js
// module id = 1142
// module chunks = 0